<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-menu #menuContextuelItemCommande popup="popup" [model]="menuContextuelEntrees"></p-menu>

<div class="grid">
    <div class="col-12">
        <p-table #dt [value]="liste?.value()" [columns]="selectedColumns" dataKey="bonTravailId" autoLayout="true"
            tableStyleClass="tableNormale" [loading]="liste == null" [(contextMenuSelection)]="selectionBonTravail"
            [rowHover]="true" [rows]="100" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]" [filterDelay]="0"
            sortMode="multiple" [multiSortMeta]="sortMeta"
            [globalFilterFields]="['numero','date','item.numero','item.description','mecanicien.nom','mecanicien.prenom','mecanicien.prenomNom','mecanicien.initiales','mecanicien.recherche','contreMaitre.nom','contreMaitre.prenom','contreMaitre.prenomNom','contreMaitre.initiales','contreMaitre.recherche']"
            (onFilter)="tableParams.setValue(dt)" (onSort)="tableParams.setValue(dt)"
            (onPage)="tableParams.setValue(dt)">
            <ng-template pTemplate="caption">
                <div class="flex align-content-center justify-content-between flex-wrap gap-2">
                    <div class="flex align-items-center gap-4 flex-wrap">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input #rechercheBdt pInputText type="text" [(ngModel)]="globalFilter"
                                (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Recherche..." />
                        </span>
                        <button *ngIf="estAutorise('bontravail_creer') || estAutorise('temp_mec')" pButton pRipple
                            icon="pi pi-plus" class="p-button-success" label="Ajouter" (click)="AjouterBdt()"></button>
                        <button pButton pRipple icon="pi pi-filter-slash" class="p-button-outlined"
                            (click)="clearFilters(dt)" pTooltip="Réinitialiser les filtres"></button>
                    </div>
                    <h5 class="titreTableau m-0">{{routerService.url.includes('soumissions') ? 'Soumissions' : 'Bons de
                        travail'}}</h5>
                    <div>
                        <p-multiSelect [options]="colonnesDisponibles" [(ngModel)]="selectedColumns"
                            optionLabel="entete" selectedItemsLabel="{0} colonnes sélectionnés"
                            [style]="{minWidth: '200px'}" placeholder="Colonnes..."></p-multiSelect>
                    </div>
                </div>
            </ng-template>

            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th pSortableColumn="numero">
                        <div class="flex justify-content-between align-items-center">
                            Numéro
                            <p-sortIcon field="numero"></p-sortIcon>
                            <p-columnFilter type="text" field="numero" display="menu" class="ml-auto">
                            </p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="dateTravail">
                        <div class="flex justify-content-between align-items-center">
                            Date
                            <p-sortIcon field="dateTravail"></p-sortIcon>
                            <p-columnFilter type="date" field="dateTravail" display="menu" class="ml-auto">
                            </p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="item.numero">
                        <div class="flex justify-content-between align-items-center">
                            Unité
                            <p-sortIcon field="item.numero"></p-sortIcon>
                            <p-columnFilter type="text" field="item.numero" display="menu" class="ml-auto">
                            </p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="item.description">
                        <div class="flex justify-content-between align-items-center">
                            Description
                            <p-sortIcon field="item.description"></p-sortIcon>
                            <p-columnFilter type="text" field="item.description" display="menu" class="ml-auto">
                            </p-columnFilter>
                        </div>
                    </th>
                    @if (EstColonneSelectionnee('heuresKm')) {
                    <th>
                        <div class="flex justify-content-between align-items-center">
                            Heures / KM
                        </div>
                    </th>
                    }
                    <th pSortableColumn="type">
                        <div class="flex justify-content-between align-items-center">
                            Statut
                            <p-sortIcon field="type"></p-sortIcon>
                            <p-columnFilter field="statut" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Any"
                                        (onChange)="filter($event.value)" optionLabel="name">
                                        <ng-template let-option pTemplate="item">
                                            <div class="multiselect-representative-option">

                                                <span class="ml-1">{{option.nom}}</span>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="contreMaitre.prenomNom">
                        <div class="flex justify-content-between align-items-center">
                            Contre-Maître
                            <p-sortIcon field="contreMaitre.prenomNom"></p-sortIcon>
                            <p-columnFilter type="text" field="contreMaitre.recherche" display="menu" class="ml-auto">
                            </p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="mecanicien.prenomNom">
                        <div class="flex justify-content-between align-items-center">
                            Mécanicien
                            <p-sortIcon field="mecanicien.prenomNom"></p-sortIcon>
                            <p-columnFilter type="text" field="mecanicien.recherche" display="menu" class="ml-auto">
                            </p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="type">
                        <div class="flex justify-content-between align-items-center">
                            Fournisseur
                            <p-sortIcon field="fournisseur.nom"></p-sortIcon>
                            <p-columnFilter type="text" field="fournisseur.nom" display="menu" class="ml-auto">
                            </p-columnFilter>
                        </div>
                    </th>
                    <th style="min-width: 10rem; width: 10rem;"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-bdt let-columns="columns">
                <tr>
                    <!--  <td style="text-align: center">
                                <button pButton (click)="OuvrirDetailBdc(bdc.bdcId)" type="button"
                                    class="p-button-secondary" icon="pi pi-angle-double-right"></button>
                            </td> -->
                    <td>
                        <a *ngIf="estAutorise('bontravail_detail')"
                            [routerLink]="'/mecanique/' + (routerService.url.includes('soumissions') ? 'soumissions' : 'bontravails') + '/' + bdt.bonTravailId">{{bdt.numero}}</a>
                        <span *ngIf="!estAutorise('bontravail_detail')">{{bdt.numero}}</span>
                        <span *ngIf="bdt.analyseBonTravail"><a class="pi pi-chart-bar ml-2" pTooltip="Voir l'analyse"
                                tooltipPosition="bottom" (click)="OuvrirAnalyseBdt(bdt)"></a></span>
                    </td>
                    <td>{{bdt.dateTravail | date:'yyyy-MM-dd'}}</td>
                    <td>
                        <div class="flex align-items-center gap-2">
                            <div *ngIf="bdt.item.photoId">
                                @defer (on viewport) {
                                <app-image-loader [documentId]="bdt.item.photoId" [width]="40" [height]="40"
                                    [title]="bdt.item.numero"></app-image-loader>
                                }
                                @placeholder {
                                <div class="flex align-items-center justify-content-center"
                                    style="height: 40px; width: 40px;">
                                    <p-skeleton width="40px" height="40px"></p-skeleton>
                                </div>
                                }
                            </div>
                            <span>{{bdt.item.numero}}</span>
                        </div>
                    </td>
                    <td>{{bdt.item.description}}</td>
                    @if (EstColonneSelectionnee('heuresKm')) {
                    <td>
                        <app-ecart-releve-bt
                            [heuresDebut]="bdt.heuresDebutCompteur"
                            [heuresFin]="bdt.heuresCompteur"
                            [kmDebut]="bdt.kmDebutCompteur"
                            [kmFin]="bdt.kmCompteur"></app-ecart-releve-bt>
                    </td>
                    }
                    <td><span [class]="'statut ' + bdt.statut.nom.toLowerCase().replace(' ', '')">
                            {{bdt.statut.nom}}
                        </span></td>
                    <td><app-employe-avec-emplacement [employe]="bdt.contreMaitre"></app-employe-avec-emplacement></td>
                    <td><app-employe-avec-emplacement [employe]="bdt.mecanicien"></app-employe-avec-emplacement></td>
                    <!-- <td *ngIf="EstColonneSelectionnee('nbItems')">{{bdt.nbItems}} ({{bdt.nbItemsTotal}})</td>
                            <td *ngIf="EstColonneSelectionnee('coutTotal')">{{bdt.coutTotal | currency}}</td>
                            <td *ngIf="EstColonneSelectionnee('employe')">{{bdt.employe | nomEmploye}}</td>
                            <td *ngIf="EstColonneSelectionnee('dateEnvoi')">{{bdt.dateEnvoi | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                            <td *ngIf="EstColonneSelectionnee('envoyeA')">{{bdt.courrielEnvoi}}</td> -->
                    <td>{{bdt.fournisseur?.nom}}</td>
                    <td class="celluleTableau">
                        <p-buttonGroup>
                            @if (estAutorise('bontravail_detail') || estAutorise('temp_mec')) {
                            <p-button icon="pi pi-eye" severity="success" size="small"
                                (onClick)="OuvrirDetailBdt(bdt.bonTravailId)" pTooltip="Voir le détail"></p-button>
                            <p-button icon="pi pi-external-link" severity="secondary" size="small"
                                (onClick)="OuvrirDetailBdtNouvelOnglet(bdt.bonTravailId)" pTooltip="Aperçu"></p-button>
                            }
                            <p-button icon="pi pi-bars" severity="secondary" size="small"
                                (onClick)="surMenuContextuelItem($event, bdt)"></p-button>
                        </p-buttonGroup>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="EstColonneSelectionnee('heuresKm') ? 10 : 9">{{activeIndex == 0 ? 'Aucune soumission.' : 'Aucun bon de travail.'}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-sidebar [(visible)]="afficherDetailBdt" [style]="{width:'95%'}" position="left">
    <app-detail-bdc [bdcId]="detailBdtId" *ngIf="afficherDetailBdt"></app-detail-bdc>
</p-sidebar>